import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://cloudunify.run.place/api';

const api = axios.create({ baseURL: API_URL });

const authInterceptor = config => {
  const token = localStorage.getItem('mcp_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
};
api.interceptors.request.use(authInterceptor);

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('mcp_token');
      localStorage.removeItem('mcp_user');
      window.location.href = '/login';
    }
    if (err.response?.data?.code === 'PLAN_LIMIT_REACHED') {
      window.dispatchEvent(new CustomEvent('plan-limit-reached', {
        detail: { message: err.response.data.error, ...err.response.data },
      }));
    }
    return Promise.reject(err);
  }
);

export const authAPI = {
  register : (data)   => api.post('/auth/register', data),
  login    : (data)   => api.post('/auth/login', data),
  me       : ()       => api.get('/auth/me'),
  profile  : (data)   => api.put('/auth/profile', data),
  upgradePlan: (data) => api.put('/auth/plan', data),
  createOrder : (data)  => api.post('/payment/create-order', data),
  verifyPayment: (data) => api.post('/payment/verify', data),
};

export const cloudAPI = {
  list       : ()         => api.get('/clouds'),
  connect    : (data)     => api.post('/clouds/connect', data),
  disconnect : (provider) => api.delete(`/clouds/${provider}`),
  pricing    : ()         => api.get('/clouds/pricing'),
  regions    : (provider) => api.get(`/clouds/regions/${provider}`),
};

export const deployAPI = {
  list    : (params) => api.get('/deployments', { params }),
  get     : (id)     => api.get(`/deployments/${id}`),
  create  : (data)   => api.post('/deployments', data),
  stop    : (id)     => api.put(`/deployments/${id}/stop`),
  start   : (id)     => api.put(`/deployments/${id}/start`),
  destroy : (id)     => api.delete(`/deployments/${id}`),
  stats   : ()       => api.get('/deployments/stats/summary'),
  syncAll : ()       => api.get('/deployments/sync/all'),
};

export const costAPI = {
  list      : (params) => api.get('/costs', { params }),
  compare   : (params) => api.get('/costs/compare', { params }),
  optimize  : ()       => api.get('/costs/optimize'),
  forecast  : ()       => api.get('/costs/forecast'),
  live      : ()       => api.get('/costs/live'),        // ← NEW real-time
  recommend : (data)   => api.post('/costs/recommend', data),
  savings   : ()       => api.get('/costs/savings'),
  invoices  : ()       => api.get('/costs/invoices'),
};

export const wakeGatewayAPI = {
  list   : ()       => api.get('/wake-gateways'),
  create : (data)    => api.post('/wake-gateways', data),
  remove : (id)      => api.delete(`/wake-gateways/${id}`),
};
export const serverGroupAPI = {
  list   : ()       => api.get('/server-groups'),
  create : (data)    => api.post('/server-groups', data),
  remove : (id)      => api.delete(`/server-groups/${id}`),
};
export const monitorAPI = {
  overview : ()   => api.get('/monitor/overview'),
  metrics  : (id) => api.get(`/monitor/${id}/metrics`),
  alerts   : ()   => api.get('/monitor/alerts'),
};
export const integrationAPI = {
  list : () => api.get('/integrations'),
};

export const optimizerAPI = {
  recommend : (data)   => api.post('/costs/recommend', data),
  compare   : (params) => api.get('/costs/compare', { params }),
  savings   : ()       => api.get('/costs/savings'),
};


export const orgAPI = {
  me         : ()              => api.get('/organizations/context/me'),
  create     : (data)          => api.post('/organizations', data),
  list       : ()              => api.get('/organizations'),
  get        : (orgId)         => api.get(`/organizations/${orgId}`),
  invite     : (orgId, data)   => api.post(`/organizations/${orgId}/invite`, data),
  updateRole : (orgId, memberId, role) => api.patch(`/organizations/${orgId}/members/${memberId}/role`, { role }),
  removeMember: (orgId, memberId) => api.delete(`/organizations/${orgId}/members/${memberId}`),
};
